'use client';

/**
 * Page cliente de recherche d'auteurs
 *
 * Utilise le composant générique EntitySearchInterface pour la recherche
 * Configuration déclarative via AUTEURS_FILTERS_CONFIG
 *
 * @module AuteursPageClient
 */

import { useTranslations } from 'next-intl';

import { AuteurCard } from '@/components/AuteurCard/AuteurCard';
import { EntitySearchInterface } from '@/components/EntitySearch/EntitySearchInterface';
import type { Meilisearch_Auteur } from '@/lib/api/meilisearch-types';
import { AUTEURS_FILTERS_CONFIG } from '@/lib/config/SearchEngine/entityFiltersConfig';
import { Env } from '@/lib/Env';

export function AuteursSearchInterface() {
  const t = useTranslations('Pages.TousLesAuteurs');

  return (
    <EntitySearchInterface<Meilisearch_Auteur>
      apiKey={Env.NEXT_PUBLIC_MEILISEARCH_KEY}
      indexName="auteurs"
      entityType="auteurs"
      // title={t('titre') || 'Nos auteurs'}
      searchPlaceholder={
        t('placeholder_recherche') || 'Rechercher un auteur par nom, prénom...'
      }
      filtersConfig={AUTEURS_FILTERS_CONFIG}
      renderHitCard={(hit) => <AuteurCard auteur={hit} />}
      customNoResultsMessages={{
        titre: t('aucun_resultat') || 'Aucun auteur trouvé',
        message:
          t('aucun_resultat_message') ||
          "Essayez d'élargir votre recherche en modifiant les filtres.",
      }}
      linkToGlobalSearchOnNoResults={false}
    />
  );
}
